import { LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers'; 
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import es from 'dayjs/locale/es';
import { TextField } from '@mui/material'; 
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Dayjs } from 'dayjs';

import './my-datepicker.css'

export interface MyDatetimePickerProps {
    labelText: string;
    value?: Dayjs | null,
    minDate?: Dayjs;
    maxDate?: Dayjs;
    setSelectedDate?: (value: Dayjs | null) => void;
}
const MyDatetimePicker = ({
    labelText, 
    value, 
    minDate, 
    maxDate, 
    setSelectedDate, 
    ...props}: MyDatetimePickerProps) => { 

    // const [minDate, setMinDate] = useState<any>(dayjs())
  
    return ( 
        <LocalizationProvider 
            dateAdapter={AdapterDayjs}
            adapterLocale={es.name}
        >
            <label 
                style={{
                    color: "#666",
                    fontFamily: "Roboto",
                    fontSize: ".875rem",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "normal",
                }}
            >
                {labelText}
            </label>
            <MobileDateTimePicker
                onChange={(days: Dayjs | null) => {
                    if (setSelectedDate) {
                        setSelectedDate(days);
                    }
                }}
                value={value}
                minDate={minDate}
                maxDate={maxDate}
                className='my-timepicker'
                slots={{
                  textField: textFieldProps => 
                    <TextField 
                        {...textFieldProps}
                        fullWidth
                        style={{marginTop: "0", }} 
                        InputProps={{
                            style: {height: "2.5rem !important",},
                            endAdornment: <AccessTimeIcon />
                        }}
                        
                    />
                }}
                format='DD/MM/YYYY hh:mm a'
                {...props}
            />
        </LocalizationProvider>
    ); 
} 


export default  MyDatetimePicker